// extracted by mini-css-extract-plugin
export var fadeIn = "_l2-1";
export var modalContent = "_l2-3";
export var overlay = "_l2-0";
export var popoverContent = "_l2-2";
export var results = "_l2-5";
export var searchInputWrapper = "_l2-4";